<script>
import BaseListing from './Listing'

export default {
  mixins: [
    BaseListing
  ],
  data () {
    return {
      gridName: 'grid_bank',
      headerTitle: { title: 'Banki', description: 'Lista' },
      service: 'core',
      actionShowUrlName: 'admin_bank_details',
      gridActions: [
        { id: 0, event: 'show', title: 'Szczegóły', icon: 'eye', acl: { service: 'core', action: 'get_bank' } }
      ]
    }
  }
}
</script>
